<template>
  <div id="success-view">
    <mt-popup v-model="show" :closeOnClickModal="0" class="success-popup">
      <div class="content">
        <div class="image"></div>
        <div class="title">{{title}}</div>
        <div class="tip">{{subTitle}}<br/>如有问题可咨询客服热线：400-1919-119</div>
        <div class="close" v-on:click='closePopClick'></div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
export default {
  props: {
    show: false,
    type: 0 // 1 提交信息成功  2 支付信息成功
    // type: {
    //   type: Number,
    //   default: 1
    // }
  },
  data () {
    return {
      title: '提交成功',
      subTitle: '信息已提交，我们会尽快与您联系'
    }
  },
  methods: {
    closePopClick: function () {
      // 取消
      this.$emit('successViewClick')
    }
  },
  mounted () {
    if (parseInt(this.type) === 1) {
      this.title = '提交成功'
      this.subTitle = '信息已提交，我们会尽快与您联系'
    }
    if (parseInt(this.type) === 2) {
      this.title = '支付成功'
      this.subTitle = '您已支付成功'
    }
  }
}
</script>

<style scoped>
  .success-popup{
    position: center;
    width: 90%;
    min-height: 100px;
    border-radius: 3px;
  }
  .content{
    padding-top: 10px;
    padding-bottom: 30px;
    line-height: 25px;
    font-size: 14px;
    color: #333333;
  }
  .content .image{
    margin-left: calc(50% - 25px);
    margin-top: 25px;
    width: 50px;
    height: 50px;
    background-image: url(../assets/success.png);
    background-size: cover;
    background-position: center center;
  }
  .content .title{
    top: 110px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-weight:bold;
    color: #4BAE4F;
    font-size: 18px;
  }
  .content .tip{
    text-align: center;
  }
  .content .close{
    position:fixed;
    position: -ms-device-fixed;
    width: 36px;
    height: 36px;
    background-image: url(../assets/close.png);
    background-size: cover;
    background-position: center center;
    margin-bottom:0px;
    left:50%;
    top:calc(100% + 35px);
    transform:translate(-50%,-50%);
    -webkit-transform:translate(-50%,-50%);
  }

</style>



// WEBPACK FOOTER //
// src/components/success-view.vue